import { Node } from '@app/models/documents/directory/node.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Translatable } from '@app/types/translatable.type';

export class AssignmentColumn extends Column {
    title = 'table.document-nodes-index.assignment';
    property = 'formattedAssignmentsText';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(node: Node): Translatable {
        return node.formattedAssignmentsText;
    }
}
